import { render, staticRenderFns } from "./evidenceList.vue?vue&type=template&id=e5b61b7a&scoped=true&"
import script from "./evidenceList.vue?vue&type=script&lang=js&"
export * from "./evidenceList.vue?vue&type=script&lang=js&"
import style0 from "./evidenceList.vue?vue&type=style&index=0&id=e5b61b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b61b7a",
  null
  
)

export default component.exports